<template>
  <div class="social-share">
    <ShareNetwork
      :network="item.icon"
      :url="config.url"
      :title="config.title"
      :description="config.description"
      v-for="(item, index) in items"
      :key="index"
    >
      <button class="spin circle">
        <svgicon
          class="icon"
          :name="'icon-' + item.icon"
          height="1.5rem"
          width="1.5rem"
        />
      </button>
    </ShareNetwork>
  </div>
</template>
<script>
export default {
  name: "SocialShare",
  computed: {
    items() {
      return this.$t("social").items;
    },
    config() {
      return this.$t("social").config;
    },
  },
  methods: {
    click(item) {
      console.log("click " + item.icon);
    },
  },
};
</script>

<style lang="scss">
.social-share {
  display: flex;
  width: fit-content;
  height: fit-content;
  flex-direction: column;
  justify-content: space-evenly;

  button {
    width: toRem(40);
    height: toRem(40);
    border-radius: 50%;

    margin: toRem(10) 0;
    cursor: pointer;
    border: 0;
    position: relative;

    &:before,
    &:after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .spin {
    width: toRem(40);
    height: toRem(40);

    &:before,
    &:after {
      top: 0;
      left: 0;
    }

    &:before {
      border: 2px solid $white_02;
    }

    &:after {
      border: 0 solid transparent;
    }

    .icon {
      fill: $ui-white;
      transition: fill 0.5s ease;
    }

    &:hover {
      &:before {
        border-top-color: $primary-yellow;
        border-right-color: $primary-yellow;
        border-bottom-color: $primary-yellow;
        transition: border-top-color 0.15s linear,
          border-right-color 0.15s linear 0.1s,
          border-bottom-color 0.15s linear 0.2s;
      }

      &:after {
        border-top: 2px solid $primary-yellow;
        border-left-width: 2px;
        border-right-width: 2px;
        transform: rotate(270deg);
        transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
      }

      .icon {
        fill: $primary-yellow;
      }
    }
  }

  .circle {
    border-radius: 100%;
    box-shadow: none;
    &:before,
    &:after {
      border-radius: 100%;
    }
  }
}

.mobile,
.tablet {
  .social-share {
    .spin {
    }
  }
}
</style>
